module.exports = __webpack_public_path__ + "img/CCLF_infographic-11.4943b665.png";